import * as sagaEffects from 'redux-saga/effects';

import handleSetFileSaga from './handleSetFileSaga';
import handleLocationChange from './handleLocationChangeSaga';

import handleImageMapsRequestSaga from './handleImageMapsRequestSaga';
import handleAddImageMapsRequestSaga from './handleAddImageMapRequestSaga';
import handleDeleteImageMapsRequestSaga from './handleDeleteImageMapRequestSaga';
import handleUpdateImageMapOrderSaga from './handleUpdateImageMapOrderSaga';

const { all } = sagaEffects;

export default function* () {
    yield all([
        handleImageMapsRequestSaga(),
        handleAddImageMapsRequestSaga(),
        handleDeleteImageMapsRequestSaga(),
        handleUpdateImageMapOrderSaga(),
        handleSetFileSaga(),
        handleLocationChange(),
    ]);
}
